import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import CloseIcon from "@material-ui/icons/Close";
import RefreshIcon from "@material-ui/icons/Refresh";

import _ from "lodash";
import { getEntitiesArray } from "../../../reducers/entitiesReducer";
import {
  successColor,
  dangerColor,
} from "../../../assets/jss/material-dashboard-pro-react";
import DefaultTable from "../../general/conf-table/ConfTable";
import fiSpreadsheetActions from "../../../actions/fiSpreadsheetActions";
import fiSpreadsheetTableColumns from "./fiSpreadsheetTableColumns";
import notificationActions from "../../general/notification/NotificationsManager/actions";
import popupActions from "../../general/popup/PopupsManager/actions";
import cacheActions from "../../../actions/cacheActions";

class FiSpreadsheetsTable extends Component {
  state = {
    id: `${Math.random()}`,
  };

  operations = [
    // {
    //   title: "Excluir",
    //   content: <CloseIcon fontSize="small" nativeColor={dangerColor} />,
    //   execute: (row) => this.onRowDelete(row.id),
    // },
    // {
    //   title: "Reimportar",
    //   content: <RefreshIcon nativeColor={successColor} />,
    //   execute: (row) => this.onRowReimport(row.id),
    // },
  ];

  componentWillMount() {
    this.onMount();
  }

  fetchFiSpreadsheets = () =>
    this.props.dispatch(fiSpreadsheetActions.fetchAll());

  reimportFiSpreadsheet = (id) =>
    this.props.dispatch(fiSpreadsheetActions.reimport(id));

  deleteFiSpreadsheet = (id) =>
    this.props.dispatch(fiSpreadsheetActions.delete(id));

  onMount = () => {
    this.props.dispatch(cacheActions.cleanCache());
    this.fetchFiSpreadsheets().catch(this.onOperationFail);
  };

  onRowReimport = (id) => {
    this.reimportFiSpreadsheet(id)
      .then(this.onReimportSucceed)
      .catch(this.onOperationFail);
  };

  onRowDelete = (id) => {
    this.deleteFiSpreadsheet(id)
      .then(this.onDeleteSucceed)
      .catch(this.onOperationFail);
  };

  onOperationFail = (apiResponse) =>
    this.props.dispatch(popupActions.handleApiResponse(apiResponse));

  onReimportSucceed = () => {
    const { dispatch } = this.props;
    const message = "A planilha foi reimportada com sucesso.";
    dispatch(notificationActions.showSuccessNotification(message));
  };

  onDeleteSucceed = () => {
    const { dispatch } = this.props;
    const message = "A planilha foi excluída com sucesso.";
    dispatch(notificationActions.showSuccessNotification(message));
  };

  render() {
    let { fiSpreadsheets } = this.props;
    fiSpreadsheets = _.sortBy(fiSpreadsheets, "id").reverse();
    const { id } = this.state;
    return (
      <DefaultTable
        id={id}
        columns={fiSpreadsheetTableColumns}
        dataList={fiSpreadsheets}
        operations={this.operations}
      />
    );
  }
}

FiSpreadsheetsTable.propTypes = {
  dispatch: PropTypes.func.isRequired,
  fiSpreadsheets: PropTypes.array.isRequired,
};

const mapStateToProps = (state) => ({
  fiSpreadsheets: getEntitiesArray("fiSpreadsheets")(state),
});

export default connect(mapStateToProps)(FiSpreadsheetsTable);
